






















import { Component, Vue, Prop } from 'vue-property-decorator';
import DocumentControls from '../../Shared/DocumentControls.vue';
import { CREATE_ORDER } from '@/queries/Order';
import { GQL_order_order } from '@/queries/__generated__/order';
import { formDataToMutationInput } from '@/app/Order';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_createOrder } from '@/queries/__generated__/createOrder';
import Order from '../Order.vue';

@Component({
  components: {
    DocumentControls,
  },
})
export default class OrderNewControls extends Vue {
  @Prop(Object) public order!: GQL_order_order;
  @Prop(Boolean) public validForm!: boolean;
  @Prop(Object) public orderRef!: Order;
  public CREATE_ORDER = CREATE_ORDER;

  public orderCreated(_: InMemoryCache, { data }: { data: GQL_createOrder }) {
    if (!data.createOrder || !data.createOrder.order) return;

    this.resetFormDirty();

    this.$sMessage.success(this.$t('Message.saveSuccess'));
    this.$router.push({
      name: 'OrdersEdit',
      params: { id: data.createOrder.order.id },
    });
  }

  private save(mutate: Function) {
    this.$emit(`save-button-click`);
    // We want to remove empty lines before saving.
    // However if we remove empty lines we trigger calculations to happen
    // in the next tick. This is why delay mutating by doing it in setTimeout.
    // This makes it be called after the calculations.
    setTimeout(() => {
      mutate({ variables: formDataToMutationInput({ order: this.order }) });
    }, 0);
  }

  private resetFormDirty() {
    this.$emit(`reset-form-dirty`);
  }
}
